import {Component, Input, OnInit} from "@angular/core";
import {GeneralService} from "../../../../services/generalService";
import {NotificationService} from "../../../../services/notificationService";
import {RouteService} from '../../../../services/routeService';
import _ from "lodash";
import {DICTIONARY} from "../../../../dictionary";


@Component({
	selector: 'threat-simulation-campaign-configuration-component',
	templateUrl: './threat-simulation-campaign-configuration.component.html',
})

export class ThreatSimulationCampaignConfigurationComponent implements OnInit {

	@Input() currentCampaign;
	@Input() configuration;

	constructor(public gs:GeneralService,
				private rs:RouteService,
				private ns:NotificationService) {
	}

	_=_;
	hours = ['00','01','02','03','04','05','06','07','08','09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'];
	minutes = ['00', '05','10','15','20','25','30','35','40','45','50','55'];

	configurationSettings: any = {};

	errMessage;
	updateInProcess = false;
	isTrainingCampaign;
	dic = DICTIONARY;


	ngOnInit() {
		this.isTrainingCampaign = this.currentCampaign.ts_type === this.dic.CONSTANTS.threatSimulationType.materials.value ||
			this.currentCampaign.ts_type === this.dic.CONSTANTS.threatSimulationType.quiz.value;

		this.configurationSettings.expired_days = this.configuration.expired_days;
		this.configurationSettings.notify_on_link_clicked = this.configuration.notify_on_link_clicked;
		this.configurationSettings.apply_default_banners = this.configuration.apply_default_banners;
		this.configurationSettings.notify_on_attachment_clicked = this.configuration.notify_on_attachment_clicked;
		this.configurationSettings.enable_security_awareness_for_mailbox = this.configuration.enable_security_awareness_for_mailbox;
		this.configurationSettings.enable_ack_reminder = this.configuration.enable_ack_reminder;
		this.configurationSettings.enable_ack_reminder_hours = this.configuration.enable_ack_reminder_hours;
		this.configurationSettings.pilot_campaign = this.configuration.pilot_campaign;
		this.configurationSettings.security_awareness_for_mailbox_expire_days = this.configuration.security_awareness_for_mailbox_expire_days;
		this.configurationSettings.send_report_when_completed = this.configuration.send_report_when_completed;
		this.configurationSettings.send_training_when_completed = this.configuration.send_training_when_completed;
		this.configurationSettings.scheduled_time_enabled = this.configuration.scheduled_time_enabled;

		if (this.configuration.scheduled_time) {
			const date = new Date(this.configuration.scheduled_time);
			this.configurationSettings.scheduled_time = new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString().slice(0, 16);
		}

		// set Campaign pace
		if (this.configuration.rate_email_delivery_hours_duration) {
			this.configurationSettings.enable_rate_email_delivery_hours_duration = true;
			this.configurationSettings.rate_email_delivery_hours_duration = this.configuration.rate_email_delivery_hours_duration;
		}
	}

	updateConfigurationTypeStatus = (key) => {
		if (this.updateInProcess) {
			return;
		}

		switch (key) {
			case 'security_awareness_for_mailbox_expire_days':
				if (!this.configurationSettings.enable_security_awareness_for_mailbox || this.configurationSettings.security_awareness_for_mailbox_expire_days > 365) {
					return;
				}
				break;

			case 'expired_days':
				if (!this.configurationSettings.expired_days || this.configurationSettings.expired_days > 365) {
					return;
				}
				break;
		}


		const data = {
			action:'configurationUpdate',
			configuration_key: key,
			value: this.configurationSettings[key]
		};

		this.updateInProcess = true;

		this.rs.updateThreatSimulationCampaign(this.currentCampaign._id, data).then(() => {
			this.currentCampaign.configuration[key] = this.configurationSettings[key];

			this.updateInProcess = false;
			this.ns.showInfoMessage('Configuration settings saved successfully');
		}, (err) => {
			this.updateInProcess = false;
		});
	};


	cancelFrequencyShowPopup = () => {
		if (this.updateInProcess) {
			return;
		}

		this.gs.showPopup({
			title: 'Cancel Frequency',
			subTitle: 'Are you sure you want to cancel all scheduled runs for this campaign?',
			type: this.dic.CONSTANTS.popupWarning,
			doneBtnText: 'Confirm',
			doneCb: () => {
				const data = {
					action:'updateRunFrequency',
					key: 'days',
					value: 0
				};

				this.updateInProcess = true;

				this.rs.updateThreatSimulationCampaign(this.currentCampaign._id, data).then((res) => {
					this.ns.showInfoMessage(res.log);
					this.currentCampaign.campaign_interval.days = 0;
					this.updateInProcess = false;
				}, (err) => {
					this.updateInProcess = false;
				});
			}
		});
	}

	modifyFrequencyExpiration = () => {
		if (this.updateInProcess) {
			return;
		}

		const currentExpirationDate = new Date(new Date(this.currentCampaign.campaign_interval.expiration).getTime() - new Date(this.currentCampaign.campaign_interval.expiration).getTimezoneOffset() * 60000).toISOString().slice(0, 16);
		const now = new Date();
		this.currentCampaign.changeDate = {
			enabled: true,
			value: currentExpirationDate,
			min: now.toISOString().slice(0,16)
		};
	}

	updateFrequencyExpiration = () => {
		const data = {
			action:'updateRunFrequency',
			key: 'expiration',
			value: new Date(this.currentCampaign.changeDate.value).toISOString()
		};

		this.updateInProcess = true;
		this.rs.updateThreatSimulationCampaign(this.currentCampaign._id, data).then((res) => {
			this.ns.showInfoMessage(res.log);
			this.currentCampaign.campaign_interval.expiration = this.currentCampaign.changeDate.value;
			this.updateInProcess = false;
			this.currentCampaign.changeDate = null;
		}, (err) => {
			this.updateInProcess = false;
			this.currentCampaign.changeDate = null;
		});
	}
}
